import {ContainerFacade} from '@igp/shared/ioc-container';
import type {IDownloadStrategy} from '@igp/shared/redux/download';
import type {IEntityReadService} from '@igp/shared/redux/entity';
import type {EntityType} from '@models';

import {DebtResponsibleMasterAgentDownloadClientStrategy, DebtResponsibleMasterAgentDownloadServerStrategy} from './downloadStrategy';
import {DebtResponsibleMasterAgentEpicsBuilder} from './epics';
import {DebtResponsibleMasterAgentsService} from './service';
import {DebtResponsibleMasterAgentsServiceTypes, type DebtResponsibleMasterAgentViewModelKeys} from './types';

export class DebtResponsibleMasterAgentContainerFacade extends ContainerFacade {
    bindAll() {
        this._container
            .bind<IEntityReadService<EntityType>>(DebtResponsibleMasterAgentsServiceTypes.service)
            .to(DebtResponsibleMasterAgentsService);
        this._container
            .bind<
                IDownloadStrategy<DebtResponsibleMasterAgentViewModelKeys>
            >(DebtResponsibleMasterAgentsServiceTypes.downloadClientStrategy)
            .to(DebtResponsibleMasterAgentDownloadClientStrategy);
        this._container
            .bind<
                IDownloadStrategy<DebtResponsibleMasterAgentViewModelKeys>
            >(DebtResponsibleMasterAgentsServiceTypes.downloadServerStrategy)
            .to(DebtResponsibleMasterAgentDownloadServerStrategy);
        this._container.bind(DebtResponsibleMasterAgentsServiceTypes.epicsBuilder).to(DebtResponsibleMasterAgentEpicsBuilder);
    }
}
